import { defineMessages } from 'react-intl';

export default defineMessages({
  infoText: { id: 'gofre.Business.Create.Form.address.bai.infoText' },
});
